export var DataTestAttributes = /*#__PURE__*/function (DataTestAttributes) {
  DataTestAttributes["ZIPCODE"] = "USER-ADDRESS-ZIPCODE";
  DataTestAttributes["COUNTRY_DROPDOWN"] = "USER-ADDRESS-COUNTRY-DROPDOWN";
  DataTestAttributes["CITY_SUGGESTIONS"] = "USER-ADDRESS-CITY-DROPDOWN";
  DataTestAttributes["CITY_SELECTED"] = "USER-ADDRESS-CITY-SELECTED";
  DataTestAttributes["COUNTRY_ERROR"] = "USER-ADDRESS-COUNTRY-ERROR";
  DataTestAttributes["CITY_ERROR"] = "USER-ADDRESS-CITY-ERROR";
  return DataTestAttributes;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/DataTestAttributes.js
// module id = 1493
// module chunks = 11